export const MissionVehicleEN = {
    "reasonMissionVehicle": {
        "column": {
            "name": "Mission Vehicle"
        },
        "title": "Manager missions vehicle reason",
        "breadCrumb": "Manager missions vehicle reason",
        "pageHeader": {
            "reasonMissionVehicle": "Manager missions vehicle reason"
        }
    }
}
